import { useRouter } from 'next/router';
import Image from 'next/image';
import Link from 'next/link';
import useDevice from '@/hooks/device';
import AccordionFooter from '../AccordionFooter';
// eslint-disable-next-line import/extensions
import { Wrapper } from './styles';
import { gaSendEvent } from '@/models/gaEvent';

const Footer = () => {
  const { basePath } = useRouter();
  const isMobile = useDevice('(max-width: 762px)');

  const { locale } = useRouter();
  return (
    <Wrapper>
      <div className="footer">
        {isMobile && locale === 'br' && (
          <>
            <AccordionFooter title="Sobre nós">
              <div className="nav-links_mobile">
                <ul>
                  <Link href={`/${basePath}`}>
                    <li>Home</li>
                  </Link>

                  <Link href="/br/blog">
                    <li>Blog</li>
                  </Link>
                  <Link href="/br/cadastro-de-parceria">
                    <li>Seja um Parceiro</li>
                  </Link>
                </ul>
              </div>
            </AccordionFooter>

            <AccordionFooter title="Canais de Ajuda">
              <div className="nav-links_mobile">
                <ul>
                  <li>
                    <Link href="/">
                      Base de Conhecimento
                    </Link>
                  </li>

                  <li>
                    <a
                      href="https://academy.cloudez.io/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Cloudez Academy
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://comunidade.cloudez.io/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Comunidade Cloudez
                    </a>
                  </li>
                </ul>
              </div>
            </AccordionFooter>

            <AccordionFooter title="A Cloudez">
              <div className="nav-links_mobile">
                <ul>
                  <li>
                    <a
                      href="https://partners.cloudez.io/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Painel Parceiro
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://status.cloudez.io/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Status dos Serviços
                    </a>
                  </li>
                  <li>
                    <Link href="/br/cadastro-de-parceria">
                      Cadastro de parceria
                    </Link>
                  </li>
                  <li>
                    <Link href="/br/termos-legais">
                      Termos Legais
                    </Link>
                  </li>
                </ul>
              </div>
            </AccordionFooter>

            <div
              className="stamps"
              style={{ margin: '1rem 0', textAlign: 'center' }}
            >
              <a
                href="https://abradi.com.br/agente/cloudez/"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  priority
                  alt="ABRADI"
                  src={`${basePath}/abradi.svg`}
                  width="115"
                  height="115"
                />
              </a>

              <a
                href="https://comunidade.cloudez.io/"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  priority
                  alt="comunidade-cloudez"
                  src={`${basePath}/comunidadeCloudez.svg`}
                  width="105"
                  height="34"
                />
              </a>
            </div>
          </>
        )}
        <div className="cloudez">
          <a href={`/${basePath}`}>
            <Image
              priority
              src="/cloudez-footer2.png"
              alt="logo"
              width={162}
              height={40}
            />
          </a>

          {locale === 'br' && (
            <>
              <div className="icons">
                <a
                  href="https://www.linkedin.com/company/cloudez"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Image
                    priority
                    alt="linkedin"
                    src={`${basePath}/linkedin.png`}
                    width="35"
                    height="34"
                  />
                </a>
                <a
                  href="https://www.facebook.com/cloudezbr"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Image
                    priority
                    alt="facebook"
                    src={`${basePath}/facebook.png`}
                    width="35"
                    height="34"
                  />
                </a>
                <a
                  href="https://www.instagram.com/cloudezbr"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Image
                    priority
                    alt="instagram"
                    src={`${basePath}/instagram.png`}
                    width="35"
                    height="34"
                  />
                </a>
              </div>
            </>
          )}
          <span>Cloudez, LLC © 2021</span>
        </div>

        {!isMobile && locale === 'br' && (
          <>
            <div className="nav-links">
              <h3>Sobre nós</h3>
              <ul>
                <li onClick={() => gaSendEvent('Link', 'Home', 'Footer')}>
                  <Link href={`/${basePath}`}>
                    Home
                  </Link>
                </li>

                <li onClick={() => gaSendEvent('Link', 'Blog ', 'Footer')}>
                  <Link href="/br/blog">
                    Blog
                  </Link>
                </li>
                <li
                  onClick={() =>
                    gaSendEvent('Link', 'Seja um Parceiro', 'Footer')
                  }
                >
                  <Link href="/br/cadastro-de-parceria">
                    Seja um Parceiro
                  </Link>
                </li>
              </ul>
            </div>

            <div className="nav-links">
              <h3>Canais de Ajuda</h3>
              <ul>

                <li><a
                  onClick={() =>
                    gaSendEvent('Link', 'Base de Conhecimento', 'Footer')
                  }
                  href="https://help.cloudez.io/"
                  target="_blank"
                  rel="noreferrer"
                >Base de Conhecimento
                </a>
                </li>

                <li>
                  <a
                    onClick={() =>
                      gaSendEvent('Link', 'Cloudez Academy', 'Footer')
                    }
                    href="https://academy.cloudez.io/"
                    target="_blank"
                    rel="noreferrer"
                  >Cloudez Academy

                  </a>
                </li>

                <li>
                  <a
                    onClick={() =>
                      gaSendEvent('Accordion', 'Comunidade Cloudez', 'Footer')
                    }
                    href="https://comunidade.cloudez.io/"
                    target="_blank"
                    rel="noreferrer"
                  >Comunidade Cloudez</a>
                </li>
              </ul>
            </div>

            <div className="nav-links">
              <h3>A Cloudez</h3>
              <ul>
                <li
                  onClick={() =>
                    gaSendEvent('Accordion', 'Painel Parceiro', 'Footer')
                  }
                >
                  <a
                    href="https://partners.cloudez.io/"
                    target="_blank"
                    rel="noreferrer"
                  >

                    Painel Parceiro
                  </a>
                </li>
                <li>
                  <a
                    onClick={() =>
                      gaSendEvent('Link', 'Status do Serviços', 'Footer')
                    }
                    href="https://status.cloudez.io/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Status dos Serviços
                  </a>
                </li>
                <li
                  onClick={() =>
                    gaSendEvent('Link', 'Termos legais', 'Footer')
                  }
                >
                  <Link href="/br/termos-legais">
                    Termos Legais
                  </Link>
                </li>
              </ul>
            </div>

            <div className="stamps">
              <a
                onClick={() => gaSendEvent('Link', 'Selo Abradi', 'Footer')}
                href="https://abradi.com.br/agente/cloudez/"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  priority
                  alt="ABRADI"
                  src={`${basePath}/abradi.svg`}
                  width="130"
                  height="130"
                />
              </a>

              <a
                onClick={() => gaSendEvent('Link', 'Selo Comunidade', 'Footer')}
                href="https://comunidade.cloudez.io/"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  priority
                  alt="comunidade-cloudez"
                  src={`${basePath}/comunidadeCloudez.svg`}
                  width="105"
                  height="34"
                />
              </a>
            </div>
          </>
        )}

        {locale === 'en' && (
          <>
            <div className="nav-links_en">
              <ul>
                <a href={`/${basePath}`}>
                  <li>Home</li>
                </a>

                <a
                  href="https://partners.cloudez.io/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <li>Partner Painel</li>
                </a>

                <a href="/en/cookies-policy">
                  <li>Cookies Policy</li>
                </a>

                <a
                  href="https://status.cloudez.io/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <li>Status</li>
                </a>
              </ul>
            </div>

            <div className="icons-en">
              <a
                onClick={() => gaSendEvent('Link', 'Linkedin ', 'Footer')}
                href="https://www.linkedin.com/company/cloudez"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  priority
                  alt="linkedin"
                  src={`${basePath}/linkedin.png`}
                  width="35"
                  height="34"
                />
              </a>
              <a
                onClick={() => gaSendEvent('Link', 'Facebook', 'Footer')}
                href="https://www.facebook.com/cloudezbr"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  priority
                  alt="facebook"
                  src={`${basePath}/facebook.png`}
                  width="35"
                  height="34"
                />
              </a>
              <a
                onClick={() => gaSendEvent('Link', 'Instagram', 'Footer')}
                href="https://www.instagram.com/cloudezbr"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  priority
                  alt="instagram"
                  src={`${basePath}/instagram.png`}
                  width="35"
                  height="34"
                />
              </a>
            </div>
          </>
        )}
      </div>

      {
        locale === 'br' && (
          <div className="pagseguro">
            <span>
              7345 W SAND LAKE RD | STE 210 OFFICE 285 | ORLANDO, FL 32819 US
            </span>
          </div>
        )
      }

      {
        locale === 'en' && (
          <div className="pagseguro_en">
            <span>
              7345 W SAND LAKE RD | STE 210 OFFICE 285 | ORLANDO, FL 32819 US
            </span>
          </div>
        )
      }
    </Wrapper >
  );
};

export default Footer;
